(() => {
  'use strict';
  const measurementEnabled = document.currentScript?.dataset.tpMeasurement === 'true';
  const emitted = new Set();
  const initialized = new WeakSet();
  const observed = new WeakSet();
  const timers = new Map();
  let observer;
  let scheduled = false;
  const isPreview = () => window.Shopify?.designMode || new URLSearchParams(location.search).has('preview_theme_id') || !!document.getElementById('PBarNextFrame');
  const allowed = () => measurementEnabled && !isPreview() && document.visibilityState === 'visible' && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const info = element => {
    const box = element?.closest('[data-miranda-tp]');
    return box ? { placement: box.dataset.tpPlacement, review_type: box.dataset.mirandaTp, product_id: box.dataset.tpProduct || undefined } : null;
  };
  function emit(name, data, once = false) {
    if (!data || !allowed()) return;
    const key = `${name}:${data.placement}:${data.product_id || ''}`;
    if (once && emitted.has(key)) return;
    if (once) emitted.add(key);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...data });
    try { window.Shopify?.analytics?.publish(`miranda:${name}`, data); } catch (_) { /* Analytics must never interrupt shopping. */ }
  }
  function clearTimers() {
    timers.forEach(timer => clearTimeout(timer));
    timers.clear();
  }
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        clearTimeout(timers.get(entry.target));
        timers.delete(entry.target);
        if (entry.isIntersecting && entry.intersectionRatio >= .5 && allowed()) {
          timers.set(entry.target, setTimeout(() => {
            timers.delete(entry.target);
            if (entry.target.isConnected) emit('trustpilot_widget_view', info(entry.target), true);
          }, 1000));
        }
      });
    }, { threshold: [.5] });
  }
  function completeReviewOfferPolicy() {
    const nativeScript = document.querySelector('script[data-miranda-product-schema]');
    const widget = document.querySelector('details.miranda-product__reviews .trustpilot-widget[data-name]');
    if (!nativeScript || !widget) return;
    let nativeData;
    try { nativeData = JSON.parse(nativeScript.textContent); } catch (_) { return; }
    let policy;
    const findPolicy = value => {
      if (!value || typeof value !== 'object' || policy) return;
      if (value.hasMerchantReturnPolicy) { policy = value.hasMerchantReturnPolicy; return; }
      Object.values(value).forEach(findPolicy);
    };
    findPolicy(nativeData);
    if (!policy) return;
    document.head.querySelectorAll('script[type="application/ld+json"]').forEach(script => {
      let data;
      try { data = JSON.parse(script.textContent); } catch (_) { return; }
      if (data['@type'] !== 'Product' || data.name !== widget.dataset.name || !data.offers) return;
      let changed = false;
      const offers = Array.isArray(data.offers) ? data.offers : [data.offers];
      offers.forEach(offer => {
        if (offer['@type'] === 'Offer' && !offer.hasMerchantReturnPolicy) {
          offer.hasMerchantReturnPolicy = policy;
          changed = true;
        }
      });
      if (changed) script.textContent = JSON.stringify(data);
    });
  }
  function scan() {
    completeReviewOfferPolicy();
    scheduled = false;
    document.querySelectorAll('[data-miranda-tp]').forEach(box => {
      if (observer && !observed.has(box)) { observer.observe(box); observed.add(box); }
      const widgets = box.matches('.trustpilot-widget') ? [box] : box.querySelectorAll('.trustpilot-widget');
      widgets.forEach(widget => {
        if (!widget.querySelector('iframe') && !initialized.has(widget) && window.Trustpilot?.loadFromElement) {
          initialized.add(widget);
          window.Trustpilot.loadFromElement(widget, true);
        }
      });
    });
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(scan); }
  }
  document.addEventListener('click', event => {
    const anchor = event.target.closest('a[data-tp-outbound], a[data-tp-reviews-link]');
    if (!anchor) return;
    if (anchor.hasAttribute('data-tp-outbound')) emit('trustpilot_outbound_click', info(anchor));
    if (anchor.hasAttribute('data-tp-reviews-link')) {
      const reviews = document.getElementById(anchor.hash.slice(1));
      if (reviews instanceof HTMLDetailsElement) { reviews.dataset.tpUserToggled = 'false'; reviews.open = true; }
      emit('trustpilot_reviews_open', info(anchor));
    }
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches('details.miranda-product__reviews[open]') && event.target.dataset.tpUserToggled === 'true') emit('trustpilot_reviews_open', info(event.target));
  }, true);
  document.addEventListener('click', event => {
    const details = event.target.closest('details.miranda-product__reviews > summary')?.parentElement;
    if (details) details.dataset.tpUserToggled = 'true';
  });
  document.addEventListener('visitorConsentCollected', () => {
    clearTimers();
    if (observer) document.querySelectorAll('[data-miranda-tp]').forEach(box => { observer.unobserve(box); observer.observe(box); });
  });
  document.addEventListener('visibilitychange', () => {
    clearTimers();
    if (document.visibilityState === 'visible' && observer) document.querySelectorAll('[data-miranda-tp]').forEach(box => { observer.unobserve(box); observer.observe(box); });
  });
  if (measurementEnabled && !window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {
      if (observer) document.querySelectorAll('[data-miranda-tp]').forEach(box => { observer.unobserve(box); observer.observe(box); });
    });
  }
  new MutationObserver(records => { if (records.some(record => record.addedNodes.length)) schedule(); }).observe(document.body, { childList: true, subtree: true });
  new MutationObserver(schedule).observe(document.head, { childList: true, subtree: true, characterData: true });
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('load', schedule, { once: true });
  scan();
})();
